import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import './index.css';

import LoginPage      from './pages/LoginPage';
import RegisterPage   from './pages/RegisterPage';
import DashboardPage  from './pages/DashboardPage';
import NewReportPage  from './pages/NewReportPage';
import CreditsPage    from './pages/CreditsPage';
import SettingsPage   from './pages/SettingsPage';
import ReportDonePage from './pages/ReportDonePage';

function PrivateRoute({ children }) {
  const { agent, loading } = useAuth();
  if (loading) return <div className="page-loading"><div className="spinner spinner-dark"/></div>;
  return agent ? children : <Navigate to="/login" replace />;
}

function PublicRoute({ children }) {
  const { agent, loading } = useAuth();
  if (loading) return <div className="page-loading"><div className="spinner spinner-dark"/></div>;
  return agent ? <Navigate to="/dashboard" replace /> : children;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/login"    element={<PublicRoute><LoginPage /></PublicRoute>} />
          <Route path="/register" element={<PublicRoute><RegisterPage /></PublicRoute>} />
          <Route path="/dashboard" element={<PrivateRoute><DashboardPage /></PrivateRoute>} />
          <Route path="/reports/new" element={<PrivateRoute><NewReportPage /></PrivateRoute>} />
          <Route path="/reports/:id/done" element={<PrivateRoute><ReportDonePage /></PrivateRoute>} />
          <Route path="/credits"  element={<PrivateRoute><CreditsPage /></PrivateRoute>} />
          <Route path="/settings" element={<PrivateRoute><SettingsPage /></PrivateRoute>} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
